import './TenantAdminIntegrationView.scss';
import '../TenantAdminBase.scss';

export { default } from './TenantAdminIntegrationView';
